import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AuthGate from "./common/authGate/AuthGate";
import { ToastProvider } from "./components/ui/toast/ToastProvider";
import { ModalProvider } from "./components/ui/modal/ModalProvider";
import { AppShell } from "./components/layout/appShell/AppShell";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { Etablissements } from "./pages/etablissements/Etablissements";
import { Circuits } from "./pages/circuits/Circuits";
import { Reservations } from "./pages/reservations/Reservations";
import { Finance } from "./pages/finance/Finance";
import { Academie } from "./pages/academie/Academie";
import { Tickets } from "./pages/tickets/Tickets";

function App() {
  return (
    <AuthGate>
      <BrowserRouter>
        <ToastProvider>
          <ModalProvider>
            <AppShell>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/etablissements" element={<Etablissements />} />
                <Route path="/etablissements/:id" element={<Etablissements />} />
                <Route path="/circuits" element={<Circuits />} />
                <Route path="/circuits/:id" element={<Circuits />} />
                <Route path="/reservations" element={<Reservations />} />
                <Route path="/reservations/:id" element={<Reservations />} />
                <Route path="/finance" element={<Finance />} />
                <Route path="/academie" element={<Academie />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route path="/tickets/:id" element={<Tickets />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </AppShell>
          </ModalProvider>
        </ToastProvider>
      </BrowserRouter>
    </AuthGate>
  );
}

export default App;
